module.exports = {
  get AsyncStorage() {
    return require('react-native').AsyncStorage
  }
}
